<mat-card class="roster-card">
  <mat-card-header>
    <mat-card-title>Plantilla (Estadísticas de Temporada)</mat-card-title>
  </mat-card-header>

  <mat-card-content class="roster-card-content">

    <ng-container *ngIf="roster && roster.length > 0; else noRoster">
      <div class="table-container">
        <table mat-table [dataSource]="roster" class="stats-table">

          <ng-container matColumnDef="playerName">
            <th mat-header-cell *matHeaderCellDef>Jugador</th>
            <td mat-cell *matCellDef="let row">
              <a [routerLink]="['/statistics/player', row.player_id]" class="player-link">
                {{ row.player_name }}
              </a>
            </td>
          </ng-container>

          <ng-container matColumnDef="matches">
            <th mat-header-cell *matHeaderCellDef class="centered-header">Partidos</th>
            <td mat-cell *matCellDef="let row" class="centered-cell">
              {{ row.total_matches_played }}
            </td>
          </ng-container>

          <ng-container matColumnDef="goals">
            <th mat-header-cell *matHeaderCellDef class="centered-header">Goles</th>
            <td mat-cell *matCellDef="let row" class="centered-cell">
              {{ row.total_goals }}
            </td>
          </ng-container>

          <ng-container matColumnDef="exclusions">
            <th mat-header-cell *matHeaderCellDef class="centered-header">Exclusiones (2min)</th>
            <td mat-cell *matCellDef="let row" class="centered-cell">
              {{ row.total_exclusions }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </ng-container>

    <ng-template #noRoster>
      <div class="no-roster-container">
        <mat-icon>group</mat-icon>
        <span>No hay datos de la plantilla disponibles para esta temporada.</span>
      </div>
    </ng-template>

  </mat-card-content>
</mat-card>
